import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';

import { VehicleGradeIcon, VehicleGrades } from '@motorway/motorway-storybook-cra';

import cypressIds from 'Components/cypress_ids.json';
import { getExteriorGradeText } from 'Components/pages/VehicleDetailsRedesign/sections/ConditionAndDamageSection/Components/VehicleDetailsExteriorGrading/ExteriorGrading/ExteriorGrading.helpers';
import Tag from 'Components/shared/Tag/Tag';
import { applyCypressData } from 'Utilities/helpers';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './VehicleExteriorGradeTag.module.scss';

const VehicleExteriorGradeTag = ({ className, exteriorGrade, noBackground, onHover, textClassName }) => {
	if (!exteriorGrade) {
		return null;
	}

	const tagClassName = cx(
		{
			[styles.gradeTag]: !noBackground,
			[styles.noBackground]: noBackground,
		},
		className,
	);

	return (
		<Tag className={tagClassName} onMouseEnter={onHover}>
			<VehicleGradeIcon grade={exteriorGrade} />
			<span
				className={cx(styles.gradeText, textClassName)}
				{...applyCypressData(cypressIds.text.vehicleExteriorGradeTag)}
			>
				{getExteriorGradeText(exteriorGrade)}
			</span>
		</Tag>
	);
};

VehicleExteriorGradeTag.defaultProps = {
	className: '',
	noBackground: false,
	onHover: noop,
	textClassName: '',
};

VehicleExteriorGradeTag.propTypes = {
	className: proPropTypes.className,
	exteriorGrade: PropTypes.oneOf(Object.values(VehicleGrades)).isRequired,
	noBackground: PropTypes.bool,
	onHover: PropTypes.func,
	textClassName: proPropTypes.className,
};

export default VehicleExteriorGradeTag;
